export var TOPUP_PROPS_EVENT = 'TopUpProps';
export var TOPUP_PROPS_EVENT_RESPONSE = 'TopUpPropsResponse';
export var TOPUP_PROPS_EVENT_REQUEST = 'TopUpPropsRequest';